module.exports = __webpack_public_path__ + "static/img/lotte-food-thumb.735918b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/lotte-food-thumb.jpg
// module id = xn40
// module chunks = 0